const deepClone = <T = Object>(value: Object): T => JSON.parse(JSON.stringify(value));

export default deepClone;
